import { useEffect, useState } from "react";
import api from "./api";

const cache = new Map();

export function fetchCommentImage(projectId, name) {
    const key = `${projectId}/${name}`;
    if (!cache.has(key)) {
        cache.set(key, api.get(`/projects/${projectId}/comment-images/${name}`, { responseType: "blob" })
            .then((r) => ({ blob: r.data, url: URL.createObjectURL(r.data) }))
            .catch((e) => { cache.delete(key); throw e; }));
    }
    return cache.get(key);
}

export function useImageUrl(projectId, name) {
    const [url, setUrl] = useState(null);
    useEffect(() => {
        if (!projectId || !name) return;
        let off = false;
        fetchCommentImage(projectId, name).then((r) => { if (!off) setUrl(r.url); }).catch(() => {});
        return () => { off = true; };
    }, [projectId, name]);
    return url;
}
